var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "st-break",
    cx: "72%",
    cy: "62%",
    r: "24%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc66",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#cc7700",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0d12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "st-sky",
    cx: "50%",
    cy: "0%",
    r: "90%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0a0d14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#0e1520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#12192a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#st-sky)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,80 Q100,60 200,90 Q280,112 360,70 Q440,28 540,65 Q640,102 720,55 Q800,8 900,55 Q990,98 1080,50 Q1170,2 1260,55 Q1340,100 1420,55 Q1500,10 1600,60 L1600,220 Q1500,200 1400,230 Q1300,260 1200,220 Q1100,180 1000,225 Q900,268 800,225 Q700,182 600,228 Q500,272 400,228 Q300,184 200,232 Q100,278 0,240 Z",
    fill: "#111820",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,60 Q80,45 160,68 Q240,90 320,55 Q400,20 480,58 Q560,95 640,55 Q720,15 800,60 Q880,105 960,60 Q1040,15 1120,62 Q1200,108 1280,60 Q1360,12 1440,58 Q1520,104 1600,65 L1600,180 Q1500,168 1400,195 Q1300,220 1200,188 Q1100,155 1000,194 Q900,232 800,190 Q700,148 600,192 Q500,235 400,192 Q300,149 200,195 Q100,240 0,200 Z",
    fill: "#0e1520",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Q150,20 280,5 Q410,-10 540,18 Q670,46 800,20 Q930,-6 1060,22 Q1190,50 1320,18 Q1450,-14 1600,10 L1600,100 Q1480,82 1360,105 Q1240,128 1120,100 Q1000,72 880,105 Q760,138 640,102 Q520,66 400,102 Q280,138 160,102 Q80,72 0,100 Z",
    fill: "#0a1018",
    opacity: 0.98
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,140 Q80,122 160,148 Q240,172 320,140 Q400,108 480,145 Q560,182 640,145 Q720,108 800,148 Q880,188 960,145 Q1040,102 1120,148 Q1200,192 1280,148 Q1360,104 1440,148 Q1520,192 1600,155 L1600,280 Q1480,260 1360,290 Q1240,320 1120,285 Q1000,250 880,285 Q760,320 640,282 Q520,244 400,285 Q280,325 160,285 Q80,255 0,282 Z",
    fill: "#131c28",
    opacity: 0.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#st-break)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M900,520 Q950,490 1000,475 Q1050,460 1100,468 Q1150,476 1200,460 Q1250,444 1300,455 Q1380,470 1440,448 Q1500,426 1600,445 L1600,580 Q1500,560 1440,575 Q1380,590 1300,572 Q1240,555 1180,568 Q1120,582 1060,565 Q1000,548 950,562 Q920,570 900,558 Z",
    fill: "#ffcc66",
    opacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M980,510 Q1040,492 1100,500 Q1160,508 1220,490 Q1280,472 1360,485 Q1440,498 1520,478 L1600,465 L1600,530 Q1500,545 1400,528 Q1320,512 1240,528 Q1160,545 1080,528 Q1020,514 980,526 Z",
    fill: "#ffdd88",
    opacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,480 Q100,462 200,480 Q300,498 400,470 Q500,442 600,470 Q700,498 800,465 Q880,435 900,452 L900,560 Q880,572 800,558 Q700,540 600,562 Q500,584 400,558 Q300,532 200,558 Q100,584 0,558 Z",
    fill: "#0e1825",
    opacity: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,520 Q100,500 200,520 Q300,540 400,512 Q500,484 600,512 Q700,540 800,510 Q880,482 920,500 L920,620 Q880,634 800,610 Q700,582 600,610 Q500,638 400,608 Q300,578 200,608 Q100,638 0,610 Z",
    fill: "#0c1520",
    opacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,580 Q80,560 160,580 Q240,600 320,572 Q400,544 480,572 Q560,600 640,570 Q720,540 800,568 Q880,596 920,575 L920,700 L0,700 Z",
    fill: "#0a1218",
    opacity: 0.85
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0,630 Q80,610 160,628 Q240,646 320,618 Q400,590 480,618 Q560,646 640,616 Q720,586 800,614 Q880,642 920,620 L920,760 L0,760 Z",
    fill: "#081018",
    opacity: 0.9
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0,680 Q60,660 120,678 Q180,696 240,668 Q300,640 360,668 Q420,696 480,666 Q540,636 600,664 Q660,692 720,662 Q780,632 840,660 Q880,678 920,660 L920,800 L0,800 Z",
    fill: "#060e16",
    opacity: 0.92
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0,750 Q40,732 80,748 Q120,764 160,738 Q200,712 240,738 Q280,764 320,736 Q360,708 400,736 Q440,764 480,736 Q520,708 560,736 Q600,764 640,736 Q680,708 720,736 Q760,764 800,738 Q840,714 880,738 L920,750 L920,900 L0,900 Z",
    fill: "#040c14",
    opacity: 0.95
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1500,520 Q1540,500 1580,488 Q1590,484 1600,480 L1600,580 Q1590,575 1575,580 Q1550,588 1510,575 Q1480,563 1460,575 Q1440,588 1410,572 L1380,558 Q1420,538 1460,530 Q1480,526 1500,520 Z",
    fill: "#0c1820",
    opacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M920,660 Q960,640 1020,650 Q1080,660 1140,638 Q1200,616 1260,638 Q1320,660 1380,638 Q1440,616 1500,640 Q1550,658 1600,640 L1600,760 L920,760 Z",
    fill: "#0d1822",
    opacity: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M920,720 Q980,700 1060,716 Q1140,732 1220,706 Q1300,680 1380,706 Q1460,732 1540,706 Q1570,698 1600,690 L1600,800 L920,800 Z",
    fill: "#0a1420",
    opacity: 0.85
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M920,780 Q980,760 1060,776 Q1140,792 1220,766 Q1300,740 1380,766 Q1460,792 1540,766 Q1570,758 1600,750 L1600,900 L920,900 Z",
    fill: "#080f18",
    opacity: 0.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0,800 Q100,780 200,798 Q300,816 400,790 Q500,764 600,790 Q700,816 800,788 Q860,770 920,784 L920,900 L0,900 Z",
    fill: "#050c14",
    opacity: 0.95
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M920,750 L940,720 Q960,700 980,715 Q1000,730 1010,710 Q1020,690 1040,705 L1060,730 Q1070,745 1060,760 L920,760 Z",
    fill: "#060d16"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1560,640 L1580,610 Q1590,595 1600,602 L1600,650 Z",
    fill: "#060d16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0,760 L10,730 Q20,710 35,725 Q50,740 60,718 Q70,696 85,710 L100,740 Q108,758 95,770 L0,770 Z",
    fill: "#040b12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140,560 Q150,548 168,542 L168,900 L140,900 Z",
    stroke: "#1a2535",
    strokeWidth: 1,
    fill: "#08111a",
    opacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M640,540 Q650,528 668,520 L668,900 L640,900 Z",
    stroke: "#1a2535",
    strokeWidth: 0.5,
    fill: "#060e18",
    opacity: 0.45
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1100,548 Q1112,534 1128,528 L1128,900 L1100,900 Z",
    stroke: "#1a2535",
    strokeWidth: 0.5,
    fill: "#060e18",
    opacity: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M200,350 L198,420",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M500,280 L498,360",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M760,260 L758,340",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.15
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1050,220 L1048,300",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.15
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1380,260 L1378,340",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.15
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M280,380 L278,455",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.18
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M600,310 L598,388",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.14
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M980,270 L978,350",
    stroke: "#c0d8f0",
    strokeWidth: 0.5,
    opacity: 0.13
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0,625 Q80,615 160,624 Q240,633 320,618 Q400,602 480,618 Q560,634 640,615 Q720,596 800,618 Q870,638 920,626 L920,645 Q870,655 800,636 Q720,614 640,634 Q560,654 480,636 Q400,618 320,636 Q240,654 160,640 Q80,626 0,645 Z",
    fill: "#c8dff0",
    opacity: 0.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 380,
    height: 900,
    fill: "#06090f",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 900,
    fill: "#040710",
    opacity: 0.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorm);
export default __webpack_public_path__ + "static/media/storm.cf2f910e2528486e0f3f09161157a13f.svg";
export { ForwardRef as ReactComponent };